import React from 'react';
import { Container } from './Container';
/**
 * A responsive template that displays the primary navigation for the application.
 * @param props A configuration for the content and display of this template.
 */
export var Layout = function (props) { return (React.createElement(Container, { className: "flex-col min-h-screen" }, props.children)); };
